<!DOCTYPE HTML>
<template>
<div class="pillgroup">
  <b-badge v-for="item in truncatedItems"
           :key="item.id"
           :variant="variant ? variant :'primary-outline'">
    {{label(item)}}
  </b-badge>
  <b-link v-if="truncate && items.length > truncate"
          @click="toggle">{{showMoreLabel}}</b-link>
</div>
</template>

<script>
export default {
  name: 'Pillgroup',
  props: {
    items: Array,
    truncate: Number,
    variant: String,
  },
  data() {
    return {
      truncateToggle: null
    }
  },
  mounted() {},
  computed: {
    truncatedItems() {
      if ( this.truncateToggle != true && this.truncate > 0 ) {
        return this.items.slice( 0, this.truncate )
      }
      return this.items
    },
    showMoreLabel() {
      return this.truncateToggle ? `Collapse` : `See all ${this.items.length}`
    }
  },
  methods: {
    label( item ) {
      if ( item.label ) { return item.label }
      if ( item.text ) { return item.text }
      return item
    },
    toggle() {
      this.truncateToggle = !this.truncateToggle
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/global.scss";

.pillgroup {
    font-family: 'Roboto';
    .badge {
        margin-right: 0.1rem;
        margin-bottom: 0.1rem;

    }
    a {
        font-size: 0.8rem;
        display: block;
        padding: 0.2rem;
        color: theme-color-level('primary',-5);
    }
}
</style>
